import script from "./ProjectFileDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectFileDownload.vue?vue&type=script&setup=true&lang=js"

import "./ProjectFileDownload.vue?vue&type=style&index=0&id=595aa91e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595aa91e"]])

export default __exports__